var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nf"},[_c('h1',[_vm._v("啊哦！")]),_c('span',[_vm._v("请求的资源不存在的说>_<")])])}]

export { render, staticRenderFns }